import {TSubscription} from 'src/containers/SmsChannel/definitions';

export enum ESubscriptionCountryType {
  RUS = 'RUS',
  OTHERS = 'OTHERS',
}

export enum ESubscriptionActionType {
  EDIT = 'EDIT',
  ADD = 'ADD',
  DELETE = 'DELETE',
}

export type TFormValues = {
  countryType: ESubscriptionCountryType;
  actionType?: ESubscriptionActionType;
  subscription?: TSubscription;
  subscriptions: string[];
};
